import {ACCEPT_ETK_START, ACCEPT_ETK_SUCCESS, ACCEPT_ETK_FAIL, ACCEPT_ETK_RESET} from './constants';
import {AcceptEtkActions, AcceptEtkState} from './types';

const initialState: AcceptEtkState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: AcceptEtkActions,
): AcceptEtkState => {
  switch (action.type) {
    case ACCEPT_ETK_START:
      return {
        ...initialState,
        loading: true,
      };
    case ACCEPT_ETK_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ACCEPT_ETK_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case ACCEPT_ETK_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
